import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { ILoyaltyHistoryParams, IReferralMembersParams } from "../types";
import { ReferralProgramService } from "../../services/referral-program.service";
import { IReferralMember } from "../../models/ReferralMember";
import { LoyaltyService } from "../../services/loyalty.service";
import { ILoyaltyHistory, ILoyaltySettings } from "../../models/Loyalty";

export const useGetLoyaltyUserBalanceQuery = (userId: string) => {
  return useQuery<
    {
      userId: string;
      loyaltyPointsBalance: number;
      earliestExpireDate: null | Date;
      earliestExpirePoints: number | null;
    },
    Error
  >({
    queryKey: [QUERY_CONSTANTS.GET_LOYALTY_USER_BALANCE, userId],
    queryFn: () => LoyaltyService.getUserBalanceByUserId(userId).then((res) => res.data),
  });
};

export const useGetLoyaltyHistoryQuery = (data: ILoyaltyHistoryParams) => {
  return useQuery<{ historyItemsLength: number; historyItems: ILoyaltyHistory[] }, Error>({
    queryKey: [QUERY_CONSTANTS.GET_LOYALTY_HISTORY, data],
    queryFn: () =>
      LoyaltyService.getLoyaltyHistory(data.userId, data.limit, data.skip).then((res) => res.data),
  });
};

export const useGetLoyaltySettingsQuery = () => {
  return useQuery<ILoyaltySettings, Error>({
    queryKey: [QUERY_CONSTANTS.GET_LOYALTY_SETTINGS],
    queryFn: () => LoyaltyService.getLoyaltySettings().then((res) => res.data),
  });
};
